import { render } from "./PatientNotes.vue?vue&type=template&id=001c05d7&ts=true"
import script from "./PatientNotes.vue?vue&type=script&lang=ts"
export * from "./PatientNotes.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__